import fetchApi from "../fetchApi";
export const ExportSellOrders = async (
    {
        ids = '',
        dateFrom = '',
        dateTo = ''
    }
) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            ids,
            created_on_gte: dateFrom,
            created_on_lte: dateTo
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/report-csv`, options);
};
